// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('custactCalcPickSelect', {
//         templateUrl: 'views/components/views/custactCalcPickSelect/custactCalcPickSelect.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'utilityService', 'custactCalcPickSelectService', 'rememberService', function ($stateParams, stateService, utilityService, custactCalcPickSelectService, rememberService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let p2PoFinishKeyno = $stateParams.p2_pofinish_keyno;
//             let custactNo = $stateParams.custact_no;

//             let variableNames = {
//                 filtervalue: ''
//             };

//             vm.model = {
//                 filterValueButtons: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') }
//                 ],
//                 setting: {},
//                 itemsListPickPackages: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE CALL
            
//             async function loadSetting() {
//                 vm.model.setting = (await custactCalcPickSelectService.getSetting({
//                     p2_pofinish_keyno: p2PoFinishKeyno,
//                     custact_no: custactNo
//                 }))[0];
//             }
            
//             async function loadPickPackages() {
//                 vm.model.itemsListPickPackages = (await custactCalcPickSelectService.listPickPackages({
//                     p2_pofinish_keyno: p2PoFinishKeyno,
//                     custact_no: custactNo
//                 }));
//             }

//             // #endregion LOAD PROCEDURE CALL

//             // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             function rememberFunc(id) {
//                 Object.keys(variableNames).forEach((key) => {
//                     switch (key) {
//                         case 'filtervalue':
//                             variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + 'filtervalue' + '/' + p2PoFinishKeyno + '/' + custactNo;
//                             break;
//                         default:
//                             break;
//                     }
//                 });

//                 if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                 let variableValue = null;

//                 switch (id) {
//                     case 'filtervalue':
//                         if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                         variableValue = vm.model.setting[id];
//                         break;
//                     default:
//                         break;
//                 }

//                 return rememberService.remember(variableNames[id], variableValue);
//             }

//             // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             // #region RESET BUTTON FUNCTION

//             function clear(id) {
//                 switch (id) {
//                     case 'searchtext':
//                         vm.model.setting.filtervalue = '';

//                         if (vm.model.setting.filtervalue === '') rememberFunc('filtervalue');
//                         break;
//                     default:
//                         break;
//                 }
//             }

//             // #endregion RESET BUTTON FUNCTION

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'filtervalue':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.filtervalue) !== true) return;

//                         vm.model.setting.filtervalue = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.filtervalue, true) !== true) return;

//                         if (vm.model.setting.filtervalue === '') rememberFunc('filtervalue');
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON BLUR MULTI FUNCTIONS

//             vm.onBlur = function (id) {
//                 switch (id) {
//                     case 'filtervalue':
//                         if (utilityService.validateParmsValue(vm.model.setting.filtervalue) !== true) return;

//                         if (vm.model.setting.filtervalue > '') rememberFunc('filtervalue');
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion ON BLUR MULTI FUNCTIONS

//             // #region ANGULAR LIFECYCLE

//             vm.$onInit = async function () {
//                 loadSetting();
//                 loadPickPackages();
//             }

//             // #endregion ANGULAR LIFECYCLE

//         }]
//     });
// })();
